import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Skeleton } from "../../Components/Needed";
import { EmptyState, StatusChip } from "../../Components/Kit";
import { fetchSmsSetup } from "../../Helpers/notificationConsoleApi";

// Notification Centre > Setup > SMS / DLT (R6.6): whether the SMS gateway is set up, and every SMS template
// with its DLT details (template id, sender, entity, the approved text) and the messages that use it.
// The DLT details are written in each template (Library > SMS); the gateway is a server setting.
const SmsSetup = ({ openTab }) => {
    const [info, setInfo] = useState(null);
    const load = useCallback(async () => {
        const result = await fetchSmsSetup();
        if (result.ok) setInfo(result.data); else { toast.error(result.message); setInfo({ live: false, templates: [] }); }
    }, []);
    useEffect(() => { load(); }, [load]);

    return (
        <div className="settings-card">
            <h5 className="fw-semibold mb-1">SMS / DLT</h5>
            <p className="text-muted small mb-3">Transactional SMS to customers, each one a template registered on DLT. Paste the approved text exactly; each {"{#var#}"} gets one value.</p>
            {!info ? <Skeleton height={160} /> : (
                <>
                    <div className="nc-health-grid mb-3">
                        <div className="nc-stat">
                            <div className="nc-stat-label">Gateway</div>
                            <div className="nc-stat-value"><StatusChip tone={info.live ? "ok" : "neutral"}>{info.live ? "Set up" : "Not set up"}</StatusChip></div>
                            <div className="nc-sub mt-1">{info.live ? "SMS can be sent." : "Add the SMS gateway address and key in the server settings (SMS_URL, SMS key), then restart the Admin backend."}</div>
                        </div>
                        <div className="nc-stat">
                            <div className="nc-stat-label">Templates</div>
                            <div className="nc-stat-value">{info.templates.length}</div>
                            <div className="nc-sub">{info.templates.filter((t) => !t.registeredText).length ? `${info.templates.filter((t) => !t.registeredText).length} without the DLT text` : "All have their DLT text"}</div>
                        </div>
                    </div>
                    {info.templates.length === 0 ? (
                        <EmptyState title="No SMS templates yet" text="Add one in the Library with its DLT template id and approved text." action={openTab ? <button type="button" className="btn btn-primary btn-sm" onClick={() => openTab("library")}>Open the Library</button> : null} />
                    ) : (
                        <div className="nc-table-wrap">
                            <table className="table table-sm align-middle nc-table">
                                <thead><tr><th>Template</th><th>DLT template id</th><th>Sender / entity</th><th>Approved text</th><th>Used by</th></tr></thead>
                                <tbody>
                                    {info.templates.map((t) => (
                                        <tr key={t.libraryId}>
                                            <td>
                                                <button type="button" className="btn btn-link btn-sm p-0 text-start fw-semibold" onClick={() => openTab("library", { libraryId: t.libraryId })}>{t.name}</button>
                                                <div className="nc-sub">{t.language} · {t.type}{t.private ? " · private" : ""}</div>
                                            </td>
                                            <td className="nc-mono">{t.dltTemplateId || t.providerTemplate || <span className="text-danger">missing</span>}</td>
                                            <td className="nc-mono">{t.senderId || "-"}{t.entityId ? <div className="nc-sub">{t.entityId}</div> : null}</td>
                                            <td className="nc-sub" style={{ maxWidth: 320 }}>{t.registeredText || <span className="text-danger">not added</span>}</td>
                                            <td className="nc-sub">{t.used || "Not used"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default SmsSetup;
